import { Chip } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'

import { useDarkMode } from '../contexts/DarkModeContext'
import { SPOT_MEDIA_TYPES } from '../utils/constants/db.constants'

const AgamiMediaTypeChip: React.FC<{
  mediaType?: number
  dataTestClass?: string
  className?: string
}> = ({ mediaType, dataTestClass, className = 'inline-block' }) => {
  const { t } = useTranslation()
  const { darkMode } = useDarkMode()

  let presentation: { color: 'indigo' | 'pink' | 'gray'; label: string } = {
    color: 'indigo',
    label: t('agami.mediaTypes.audio'),
  }
  if (mediaType === SPOT_MEDIA_TYPES.VIDEO) {
    presentation = { color: 'pink' as const, label: t('agami.mediaTypes.video') }
  } else if (mediaType === SPOT_MEDIA_TYPES.NONE) {
    presentation = { color: 'gray' as const, label: t('agami.mediaTypes.none') }
  }

  return (
    <Chip
      variant={darkMode ? 'filled' : 'ghost'}
      size="sm"
      className={className}
      color={presentation.color}
      value={presentation.label}
      {...(dataTestClass && { 'data-testclass': dataTestClass })}
    />
  )
}

export default AgamiMediaTypeChip
